export default __webpack_public_path__ + "static/media/bert.58b97a3d.jpg";